export interface Fournisseur{
    clientFinal_id:number
    fournisseur_id:number
    fournisseur_name:string
    email:string
    website_link:string
    linkedin_link:string
    type:string
    domain:string
    year_of_creation:string
    nb_days :string
    date_first_presentation :string
   
    }
    export const headerColumns10=[
        { checked: true, name: 'Entreprise', code: 'name' },
        { checked: true, name: 'Type', code: 'type' },
        { checked: true, name: 'Nom vis à vis ', code: 'nom_vis_a_vis' },
        { checked: true, name: 'nombre de jours de prestation total', code: 'nb_days' },
        { checked: true, name: 'nombre des consultant en mission', code: 'nb_consultant_en_mission' },
        { checked: true, name: 'nombre de jours de prestation dernier mois', code: 'days_of_prestation' },
        { checked: true, name: 'Dernière connexion', code: 'last_connection' },
      
      ];
      export const headerColumns20=[

        { checked: true, name: 'Entreprise',code: 'name' },
        { checked: true, name: 'Consultant',code: 'type' },
        // { checked: true, name: 'Nom vis à Nombre des Consultant ext en mission', code:'nom_vis_a_vis' },
        { checked: true, name: 'Nombre des Consultant ext en mission', code:'nb_consultant_en_mission' },
        { checked: true, name: 'Nombre jours de préstation', code:'days_of_prestation' },
        { checked: true, name: 'Nombre de jours de préstation dernier mois', code:'nb_days' },
        { checked: true, name: 'Dernière connexion', code:'last_connection' },
        
      
      ];